<template>
    <div class="topbar mobile">

        <!-- APP NAME -->
        <div class="left-area">
            <router-link :to="`/dashboard/${$storex.getters?.getPageData?.id}/home`" class="app-name"
                v-if="$storex.getters?.getPageData?.id != undefined">
                <img src="../assets/logo.svg" style="width: 140px !important" />

            </router-link>
            <div :to="`/`" class="app-name" v-else>
                <router-link to="/"> 
                <img src="../assets/logo.svg" style="width: 140px !important" />
            </router-link>

            </div>
            <!-- <span class="badge-beta">BETA</span> -->
        </div>

        <div class="d-flex justify-content-between ">

            <div style="margin-right: 4px;">
                <CreditCard v-show="pageInfo?.settings?.business && Object.keys(pageInfo.settings.business).length" />
            </div>

            <!-- ปุ่มเปิดเมนู (MOBILE) -->
            <button class="menu-button" @click="showMobileMenu = !showMobileMenu">
                <span class="material-symbols-outlined">
                    {{ showMobileMenu ? "close" : "menu" }}
                </span>
            </button>
        </div>
        <!-- MOBILE MENU (BOTTOM SHEET STYLE) -->
        <transition name="slide" style="    z-index: 100;">
            <div v-if="showMobileMenu" class="mobile-sheet">


                <div class="sheet-section" v-if="$route.params.id">
                    <button @click="goBack" class="sheet-item">
                        <span class="sheet-item-icon">
                            <span class="material-symbols-outlined">sync_alt</span>
                        </span>
                        <span class="sheet-item-text">
                            <span class="sheet-item-title">{{ $storex.getters?.getPageData?.name }}</span>
                            <span class="sheet-item-sub">สลับไปเพจอื่น</span>
                        </span>
                        <img :src="$storex.getters.getPageData?.picture?.data?.url" class="avatar-mini" />
                    </button>
                </div>

                <!-- ✅ ใหม่ — "แก้ไขข้อมูลธุรกิจ" ลิงก์ไปหน้า page-setting (PageSettingScreen.vue) —
                     v-if เดียวกับด้านบน เพราะการแก้ข้อมูลธุรกิจต้องมี pageId อยู่ใน route ก่อนเสมอ -->
                <div class="sheet-section" v-if="$route.params.id">
                    <router-link :to="{ name: 'page-setting', params: { id: $route.params.id } }" class="sheet-item"
                        @click="showMobileMenu = false">
                        <span class="sheet-item-icon">
                            <span class="material-symbols-outlined">storefront</span>
                        </span>
                        <span class="sheet-item-text">
                            <span class="sheet-item-title">แก้ไขข้อมูลธุรกิจ</span>
                            <span class="sheet-item-sub">ชื่อร้าน คำอธิบาย เวลาเปิด-ปิด</span>
                        </span>
                        <span class="material-symbols-outlined sheet-item-chevron">chevron_right</span>
                    </router-link>
                </div>

                <!-- 🚨 ใหม่ — เดิมกด "Sign out" ออกจากระบบทันทีไม่มีการยืนยัน กดพลาดครั้งเดียวหลุดออก
                     จากระบบเลย เปลี่ยนเป็นเรียก confirmLogout() แทน (เด้ง SweetAlert ถามยืนยันก่อน
                     ค่อยเรียก logout() จริง — ใช้ pattern เดียวกับ confirm dialog อื่นๆ ในระบบ) -->
                <div class="sheet-section">
                    <button @click="confirmLogout" class="sheet-item sheet-item--danger">
                        <span class="sheet-item-icon sheet-item-icon--danger">
                            <span class="material-symbols-outlined">logout</span>
                        </span>
                        <span class="sheet-item-text">
                            <span class="sheet-item-title">ออกจากระบบ</span>
                        </span>
                    </button>
                </div>


            </div>
        </transition>

    </div>

    <div class="d-flex justify-content-between align-items-lg-center py-1 flex-column flex-lg-row topbar notmobile"
        style="z-index: 10;">

        <b class=" mb-3 mb-lg-0">
            <router-link :to="`/dashboard/${$storex.getters?.getPageData?.id}/home`" class="app-name"
                v-if="$storex.getters?.getPageData?.id != undefined">
                <img src="../assets/logo.svg" style="width: 140px !important" />

            </router-link>
            <div v-else>
                <router-link to="/">
                    <img src="../assets/logo.svg" style="width: 140px !important" />
                </router-link>

            </div>
            <!-- <span class="badge text-bg-dark" style="font-size: 8px !important">BETA</span> -->
        </b>
        <div class="hstack gap-3" v-if="$storex.getters?.getToken">
            <div>
                <CreditCard
                    v-show="showCreditAndPackageArea"
                    :creditLastReset="formatDate(subscription?.creditLastReset)" />

            </div>



            <div class="relative" @mouseenter="showPackage = true" @mouseleave="showPackage = false"
                v-if="showCreditAndPackageArea">

                <router-link :to="packageButtonLink" class="credit-button"
                    @mouseenter="hoverMessage = true" @mouseleave="hoverMessage = false">
                    <!-- 🚨 ปรับใหม่ — เดิมใช้ <ButtonLoading /> (overlay ลอยทับ) คลุม .credit-inner ที่
                         "render อยู่เสมอไม่ว่าจะโหลดเสร็จหรือยัง" แปลว่าระหว่างรอ subscription โหลด
                         เนื้อหาจริงข้างใต้แสดงค่า undefined/NaN อยู่ (แค่ถูกบังด้วย overlay เฉยๆ ไม่ใช่
                         skeleton จริง) เปลี่ยนเป็น v-if/v-else แยกเนื้อหาจริงกับ skeleton ให้เด็ดขาด
                         ตรงกับ pattern เดียวกับ CreditCard.vue -->
                    <!-- ✅ แก้ — skeleton เฉพาะตอน "กำลังโหลดจริง" เท่านั้น (เดิมดูแค่ subscription?.name — ร้านที่
                         ไม่มีเอกสาร subscription ได้ skeleton ค้างตลอดไป) โหลดแล้วไม่มีแพ็กเกจ/โหลดไม่สำเร็จ
                         → โชว์ปุ่ม "เลือกแพ็กเกจ" แทน -->
                    <div v-if="!subscription?.name && subscriptionLoading" class="credit-skeleton">
                        <span class="credit-skel credit-skel-line1"></span>
                        <span class="credit-skel credit-skel-line2"></span>
                    </div>

                    <div v-else-if="!subscription?.name" class="credit-inner">
                        <span class="material-symbols-outlined">add_card</span>
                        <span>เลือกแพ็กเกจ</span>
                        <p class="tooltip-expire m-0">
                            <span style="display: flex; align-items: center;">
                                {{ subscriptionStatus === 'error' ? 'โหลดข้อมูลไม่สำเร็จ' : 'ยังไม่มีแพ็กเกจ' }}
                            </span>
                        </p>
                    </div>

                    <!-- ✅ ใหม่ — ร้านแพ็กเกจเริ่มต้น (Trial, 0 เครดิต): ไม่โชว์วันหมดอายุ (Autopilot ไม่ผูกกับอายุแพ็กเกจ)
                         เปิด Autopilot แล้ว → โควตาข้อความฟรีที่เหลือ · ยังไม่เปิด → ชวนเปิด (ไปหน้าแรกที่มีการ์ด Autopilot) -->
                    <div v-else-if="isTrial" class="credit-inner">
                        <span class="material-symbols-outlined" v-if="!hoverMessage">{{ autopilotActive ? 'smart_toy' : 'bolt' }}</span>
                        <span>{{ hoverMessage ? (autopilotActive ? 'ดูแพ็กเกจ' : 'ดูวิธีเปิด') : (autopilotActive ? 'Autopilot' : 'เปิด Autopilot') }}</span>
                        <p class="tooltip-expire m-0" :class="{ expired: autopilotActive && autopilotPool.isEmpty }">
                            <span style="display: flex; align-items: center;">
                                <template v-if="autopilotActive">
                                    {{ autopilotPool.isEmpty ? 'โควตาเดือนนี้หมดแล้ว' : `AI แชทฟรี เหลือ ${autopilotPool.remaining} ข้อความ` }}
                                </template>
                                <template v-else>ใช้ AI ตอบแชทฟรี</template>
                            </span>
                        </p>
                    </div>

                    <div class="credit-inner" v-else>
                        <span class="material-symbols-outlined" v-if="!hoverMessage">
                            package
                        </span>

                        <span>{{ hoverMessage ? 'เปลี่ยนแพ็กเกจ' : subscription?.name }} </span>
                        <p class="tooltip-expire m-0" :class="{ expired: isExpired(subscription?.creditLastReset) }">

                            <span v-if="isExpired(subscription?.creditLastReset)"
                                style="display: flex; align-items: center;">
                                <span class="material-symbols-outlined">
                                    hourglass_bottom
                                </span> หมดอายุแล้ว
                            </span>

                            <span v-else style="display: flex; align-items: center;">

                                <span class="material-symbols-outlined">
                                    hourglass_top
                                </span>เหลือ {{ remainingDays(subscription?.creditLastReset) }} วัน
                            </span>
                        </p>


                    </div>
                </router-link>


                <!-- <PackageCardTooltip :visible="showPackage" @hide="showPackage = false" :fullScreen="true"
                    @keep-visible="showPackage = true" @upgrade="goUpgrade" /> -->
            </div>

            <div class="relative" v-if="$route.params.id">
                <button @click="goBack" class="credit-button">
                    <span class="material-symbols-outlined" style="margin-right: 8px;">
                        sync_alt
                    </span>
                    <span style="margin-right: 8px;">{{ $storex.getters?.getPageData?.name }}</span>
                    <img :src="$storex.getters.getPageData?.picture?.data?.url" alt="avatar" class="avatar"
                        style="width: 20px;border-radius: 100%;">

                </button>


            </div>

            <div class="profile">
                <div class="dropdown position-relative" @click.stop>
                    <a href="#" class="d-flex align-items-center text-dark text-decoration-none dropdown-toggle"
                        @click.prevent="toggleDropdown">

                        <img class="user-initial" :src="`${$storex.getters?.getUserData?.photoURL}`">
                        </img>
                        <!-- <span class="ms-2">{{ $storex.getters.getUserData.name }} </span> -->
                    </a>
                    <ul v-show="showDropdown" class="dropdown-menu text-small show-dropdown">

                        <!-- ✅ ใหม่ — "แก้ไขข้อมูลธุรกิจ" ลิงก์ไปหน้า page-setting เหมือนกับใน mobile
                             sheet ด้านบน — v-if กันไว้เพราะต้องมี pageId ใน route ก่อนถึงจะแก้ได้ -->
                        <li v-if="$route.params.id">
                            <router-link :to="{ name: 'page-setting', params: { id: $route.params.id } }"
                                class="dropdown-item" @click="showDropdown = false">
                                <span class="material-symbols-outlined">storefront</span>
                                แก้ไขข้อมูลธุรกิจ
                            </router-link>
                        </li>
                        <li v-if="$route.params.id" class="dropdown-divider-line"></li>

                        <!-- 🚨 ใหม่ — เดิมกด "Sign out" ออกจากระบบทันทีไม่มีการยืนยัน เปลี่ยนเป็นเรียก
                             confirmLogout() แทน (เหตุผลเดียวกับ mobile sheet ด้านบน) -->
                        <li>
                            <button class="dropdown-item dropdown-item--danger" @click.stop="confirmLogout">
                                <span class="material-symbols-outlined">logout</span>
                                ออกจากระบบ
                            </button>

                        </li>

                    </ul>
                </div>
            </div>



        </div>
        <div v-else>
            <button class="btn btn-start btn-icon-text" @click="$router.push('/login')">
                <!-- <span class="material-symbols-outlined" style="font-size: 14px;">
                    login
                </span> -->
                เริ่มต้นใช้งาน</button>
        </div>
    </div>
</template>

<script>
import { computeQrOnlyBenefitStatus, describeQrFreePool } from "@/utils/qrOnlyBenefit";
import emitter from '../helpers/eventBus';
import CreditCard from '../components/CreditCard'
import PackageCardTooltip from '../components/PackageCardTooltip'
// 🚨 ใหม่ — ButtonLoading ไม่ได้ใช้ในเทมเพลตแล้ว (แทนที่ด้วย skeleton — ดู comment เหตุผลเต็มๆ ตรงปุ่ม
// แพ็กเกจในเทมเพลต) ตัด import/register ออกกันเป็น dead import



export default {
    name: "SidebarMenu",
    components: { CreditCard, PackageCardTooltip },
    computed: {
        appName() {
            return process.env.VUE_APP_NAME || 'MyApp'
        },
        pageInfo() {
            return this.$storex.getters["pageModule/getPageInfo"];
        },
        // 🚨 ใหม่ — แก้บั๊ก "ปุ่มหายไปเฉยๆ ระหว่างโหลด ไม่มี skeleton โผล่เลย" — เดิม v-if/v-show ของ
        // ปุ่มเครดิต/แพ็กเกจเช็คแค่ "pageInfo?.settings?.business && Object.keys(...).length" ตัวเดียว
        // ซึ่งเป็น false ทั้ง 2 เคสที่ต่างกันโดยสิ้นเชิง: (1) pageInfo ยังไม่มาเลย (กำลังโหลดอยู่ ยังไม่รู้
        // ผล) กับ (2) pageInfo มาแล้วจริงๆ แต่ร้านนี้ยังไม่เคยกรอกข้อมูลธุรกิจเลย (ยัง onboarding ไม่เสร็จ)
        // — เดิมปฏิบัติเหมือนกันหมดคือ "ซ่อน" ทำให้ระหว่างโหลด (เคส 1) ปุ่มหายไปเฉยๆ ทั้งที่ควรโชว์
        // skeleton แทน ส่วนเคส 2 (โหลดเสร็จแล้วแต่ไม่มีข้อมูลจริงๆ) ถึงควรซ่อนจริง — แยก 2 เคสนี้ออกจากกัน
        // ด้วย computed นี้: โชว์ (ไม่ว่าจะเป็น skeleton หรือเนื้อหาจริง) ถ้า "ยังไม่รู้ผล" (pageInfo
        // เป็น null/undefined) หรือ "รู้ผลแล้วว่ามีข้อมูลธุรกิจจริง" — ซ่อนเฉพาะกรณีเดียวคือรู้ผลแล้วว่า
        // ไม่มีข้อมูลธุรกิจจริงๆ เท่านั้น
        showCreditAndPackageArea() {
            if (this.isPages) return false;
            if (!this.pageInfo) return true; // ยังไม่รู้ผล — โชว์ไว้ก่อน (จะได้เห็น skeleton)
            const business = this.pageInfo?.settings?.business;
            return !!(business && Object.keys(business).length);
        },
        // ✅ ใหม่ — สถานะโหลดแพ็กเกจ (ดู store/module/subscriptionModule.js)
        subscriptionStatus() {
            return this.$storex.getters["subscriptionModule/getSubscriptionStatus"];
        },
        subscriptionLoading() {
            return this.subscriptionStatus === "idle" || this.subscriptionStatus === "loading";
        },
        // แพ็กเกจเริ่มต้น (packageId 0, 0 เครดิต — backend utils/trialSubscription.js)
        isTrial() {
            return Number(this.subscription?.packageId) === 0;
        },
        // ✅ ใหม่ — สถานะ Autopilot (QR-only + Stripe พร้อมรับเงิน) จาก pageInfo.settings ที่ sync realtime อยู่แล้ว
        autopilotActive() {
            const st = this.pageInfo?.settings;
            return computeQrOnlyBenefitStatus(st?.payment?.enabledMethods, st?.stripe?.chargesEnabled === true) === "active";
        },
        autopilotPool() {
            return describeQrFreePool(this.subscription?.qrFreePool);
        },
        packageButtonLink() {
            const id = this.$route.params.id;
            return this.isTrial && !this.autopilotActive ? `/dashboard/${id}` : `/dashboard/${id}/package`;
        },
        subscription() {
            return this.$storex.getters["subscriptionModule/getSubscription"];
        },
        isPages: function () {
            // Compare the current route's name with the provided name
            return this.$route.name == 'home';
        },

    },

    data() {
        return {
            showDropdown: false,
            showPackage: false,
            hoverMessage: false,
            showMobileMenu: false,
            packageInfo: {
                name: "Starter Plan",
                used: 1,
                limit: 10,
            },
            isLoaded: false
        };
    },
    mounted() {
        // เปลี่ยนเป็น 'click' แทน 'mousedown'
        window.addEventListener("click", this.handleClickOutside);
        // ✅ ใหม่ — กันกรณีหน้าที่ไม่มี CreditCard.vue (ตัวที่สั่งโหลดแพ็กเกจปกติ) แล้วสถานะค้าง "idle"
        //    = skeleton ค้าง: รอ 3 วิ ถ้ายังไม่มีใครสั่งโหลด ให้ Tabnav สั่งเอง
        this.subscriptionKick = setTimeout(() => {
            const pageId = this.$route?.params?.id;
            if (pageId && this.subscriptionStatus === "idle") {
                this.$storex.dispatch("subscriptionModule/loadSubscription", pageId);
            }
        }, 3000);
    },
    beforeUnmount() {
        window.removeEventListener("click", this.handleClickOutside);
        clearTimeout(this.subscriptionKick);
    },

    methods: {
        formatDate(ts) {
            return new Date(ts).toLocaleString("th-TH", {
                dateStyle: "medium",
                timeStyle: "short"
            });
        },
        handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
                this.showDropdown = false;
            }
        },
        handleDelete() {
            emitter.emit('deleteDocument');
        },
        handleSave() {
            emitter.emit('saveDocument');
        },
        goUpgrade() {
            this.$router.push('/upgrade');
        },
        remainingDays(ts) {
            const now = Date.now();
            const diff = now - Number(ts || 0);
            const THIRTY = 30 * 24 * 60 * 60 * 1000;

            if (diff >= THIRTY) return 0;

            return Math.ceil((THIRTY - diff) / (24 * 60 * 60 * 1000));
        },
        isExpired(creditLastReset) {
            const THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;
            return Date.now() - Number(creditLastReset || 0) > THIRTY_DAYS;
        },
        goBack() {
            try {
                this.$store.dispatch("pageModule/removePageInfo");

                this.$store.dispatch('removePageData');

                this.$router.push('/');

            } catch (error) {
                console.log(error)
            }

        },
        toggleDropdown() {
            this.showDropdown = !this.showDropdown;
        },
        // 🚨 ใหม่ — เดิม logout() ถูกเรียกตรงๆ จากปุ่ม ออกจากระบบทันทีไม่มีการยืนยันเลย กดพลาดครั้งเดียว
        // (เช่นมือลื่นบนมือถือ) หลุดออกจากระบบทันที — เพิ่มชั้นยืนยันก่อนด้วย SweetAlert (pattern
        // เดียวกับ confirm dialog อื่นๆ ในระบบ เช่น ลบสินค้า/ลบกิจกรรม) เรียกจากทั้ง mobile sheet และ
        // desktop dropdown แทนการเรียก logout() ตรงๆ
        async confirmLogout() {
            this.showDropdown = false;
            const result = await this.$swal.fire({
                title: "ออกจากระบบ?",
                text: "คุณต้องการออกจากระบบใช่ไหม",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "ออกจากระบบ",
                cancelButtonText: "ยกเลิก",
                confirmButtonColor: "#dc2626",
            });
            if (result.isConfirmed) {
                this.logout();
            }
        },
        logout() {
            this.showDropdown = false;
            this.showMobileMenu = false;

            // ป้องกัน clickOutside หรือ event อื่นรบกวน
            setTimeout(() => {
                this.$router.push('/logout');
            }, 10);
        }

    },

};

</script>

<style scoped>
.profile {
    border: 1px solid var(--gray-1);
    border-radius: 50px;
    padding: 0.2em 0.3em;
}

/* ✅ ใหม่ — dropdown item เดิมไม่มี CSS ของตัวเองเลย อาศัยแค่ style default ของ Bootstrap
   (.dropdown-item) เปล่าๆ ดูธรรมดามาก — ใส่ icon + hover state + divider + สไตล์สีแดงสำหรับ
   ปุ่มออกจากระบบ (destructive action ควรแยกให้เห็นชัดจากรายการอื่น) */
.dropdown-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    font-size: 0.88rem;
    color: #1a1a24;
    border: none;
    background: none;
    width: 100%;
    text-align: left;
    cursor: pointer;
    transition: background 0.15s ease;
}

.dropdown-item .material-symbols-outlined {
    font-size: 18px;
    color: #6b6b76;
}

.dropdown-item:hover {
    background: #f5f5f8;
    color: #1a1a24;
}

.dropdown-item--danger {
    color: #dc2626;
}

.dropdown-item--danger .material-symbols-outlined {
    color: #dc2626;
}

.dropdown-item--danger:hover {
    background: #fef2f2;
}

.dropdown-divider-line {
    height: 1px;
    background: #eee;
    margin: 4px 0;
}

.btn-start {
    background: #111;
    color: #fff;
    font-size: 1rem;
    font-weight: 500;
    border-radius: 50px;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
}

.btn-start:hover {
    background: #333;
    color: #fff;
    transform: translateY(-2px);
}

.credit-button {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    color: #111827;
    border-radius: 9999px;
    padding: 0.45rem 1rem;
    font-size: 0.85rem;
    font-weight: 500;
    text-decoration: none;
    transition: all 0.25s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

.credit-button:hover {
    background: #2563eb;
    color: #fff;
    border-color: #2563eb;
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
    transform: translateY(-1px);
}

.credit-inner {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    transition: color 0.3s ease, transform 0.2s ease;
}

.credit-inner span {
    transition: all 0.25s ease;
}

.credit-inner .material-symbols-outlined {
    font-size: 18px;
}

/* ✅ ใหม่ — skeleton แทนที่ ButtonLoading overlay เดิมของปุ่มแพ็กเกจ (ดู comment เหตุผลเต็มๆ ในเทมเพลต)
   ทำเป็น 2 แถว (ชื่อแพ็กเกจ + จำนวนวันที่เหลือ) ให้ตรงกับโครงจริงของ .credit-inner ด้านบน */
.credit-skeleton {
    display: flex;
padding: 4px;
    gap: 5px;
    width: 100%;
}

.credit-skel {
    border-radius: 6px;
    background: linear-gradient(
        90deg,
        #f3f4f6 25%,
        #e5e7eb 37%,
        #f3f4f6 63%
    );
    background-size: 400% 100%;
    animation: credit-skel-shimmer 1.4s ease-in-out infinite;
}

.credit-skel-line1 {
    width: 90px;
    height: 13px;
}

.credit-skel-line2 {
    width: 60px;
    height: 11px;
}

@keyframes credit-skel-shimmer {
    0% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
}

@media (prefers-reduced-motion: reduce) {
    .credit-skel {
        animation: none;
    }
}

.topbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 0 16px;
    min-height: var(--pr-topbar-h, 68px);
    flex-shrink: 0;
    border-bottom: 1px solid #eee;
    position: sticky;
    top: 0;
    z-index: 20;
}

/* APP NAME */
.left-area {
    display: flex;
    align-items: center;
    gap: 6px;
}

.app-name {
    font-size: 1.1rem;
    font-weight: 700;
    color: #111;
    text-decoration: none;
}

.badge-beta {
    background: #111;
    color: #fff;
    font-size: 8px;
    padding: 2px 6px;
    border-radius: 6px;
}

/* PROFILE */
.profile-area {
    position: relative;
}

.profile-img {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    cursor: pointer;
}

.dropdown-menu {
    position: absolute;
    right: 0;
    top: 44px;
    background: #fff;
    border-radius: 12px;
    border: 1px solid #ddd;
    width: 150px;
    padding: 6px 0;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
    animation: fadeIn 0.2s;
}

/* BUTTON: MOBILE MENU */
.menu-button {
    display: none;
    background: #111;
    color: #fff;
    padding: 10px 14px;
    border-radius: 12px;
    border: none;
    font-weight: 600;
}

.notmobile {
    display: flex !important
}

.mobile {
    display: none !important
}

@media (max-width: 1250px) {
    .menu-button {
        display: flex;
        align-items: center;
    }

    .notmobile {
        display: none !important
    }

    .mobile {
        display: flex !important
    }
}

/* SHEET MENU */
.mobile-sheet {
    position: fixed;
    top: var(--pr-topbar-h, 68px);
    left: 0;
    right: 0;
    background: #fff;
    padding: 18px;
    /* border-radius: 20px 20px 0 0; */
    box-shadow: 0 16px 16px rgba(0, 0, 0, 0.05);
    animation: slideUp 0.25s ease-out;

}

.sheet-section {
    margin-bottom: 14px;
}

/* 🚨 ปรับใหม่ — เดิม .sheet-btn เป็นกล่องเทาแบนๆ ไอคอน+ข้อความเรียงกันเฉยๆ ทุกปุ่มหน้าตาเหมือนกันหมด
   ไม่ว่าจะเป็นปุ่มสลับเพจ/แก้ไขข้อมูล/ออกจากระบบ ดูไม่มีลำดับความสำคัญเลย — เปลี่ยนเป็น .sheet-item
   (ไอคอนอยู่ในชิปวงกลม + ชื่อรายการ + คำอธิบายสั้นๆ ถ้ามี + ลูกศรบอกว่ากดแล้วไปหน้าอื่นได้) ดูเป็น
   list menu ที่มีลำดับชั้นชัดเจนกว่าเดิม ส่วน "ออกจากระบบ" แยกโทนสีแดงให้เห็นชัดว่าเป็น action ที่ต่างจาก
   รายการอื่น (destructive action) */
.sheet-item {
    width: 100%;
    padding: 12px 14px;
    background: #f7f7f7;
    border-radius: 14px;
    border: 1px solid #ececec;
    font-size: 0.95rem;
    display: flex;
    align-items: center;
    gap: 12px;
    color: #111;
    text-decoration: none;
    transition: background 0.15s ease, border-color 0.15s ease;
}

.sheet-item:hover {
    background: #efefef;
}

.sheet-item-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: #fff;
    border: 1px solid #e5e5e5;
    flex-shrink: 0;
}

.sheet-item-icon .material-symbols-outlined {
    font-size: 20px;
    color: #333;
}

.sheet-item-icon--danger {
    background: #fef2f2;
    border-color: #fecaca;
}

.sheet-item-icon--danger .material-symbols-outlined {
    color: #dc2626;
}

.sheet-item-text {
    display: flex;
    flex-direction: column;
    text-align: left;
    min-width: 0;
    flex: 1;
}

.sheet-item-title {
    font-weight: 600;
    color: #111;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.sheet-item-sub {
    font-size: 0.78rem;
    color: #8a8a94;
    margin-top: 2px;
}

.sheet-item-chevron {
    font-size: 20px;
    color: #b5b5bd;
    flex-shrink: 0;
}

.sheet-item--danger .sheet-item-title {
    color: #dc2626;
}

.sheet-item--danger {
    background: #fff;
    border-color: #fee2e2;
}

.sheet-item--danger:hover {
    background: #fef2f2;
}

/* Avatar mini */
.avatar-mini {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    margin-left: auto;
    flex-shrink: 0;
}

/* ANIMATION */
@keyframes slideUp {
    from {
        transform: translateY(-30px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.slide-enter-active,
.slide-leave-active {
    transition: all 0.25s;
}

.slide-enter-from,
.slide-leave-to {
    transform: translateY(-20px);
    opacity: 0;
}

.tooltip-expire {
    font-size: 0.8rem;
    /* margin-top: 4px; */
    color: #059669;
    /* เขียว */
    font-weight: 500;
}

.tooltip-expire.expired {
    color: #dc2626;
    /* แดง */
    font-weight: 600;
}
</style>